import { RichMenuAPIClient } from '../../api/impl/LineRichMenuAPIClient';

export default class StubLineRichMenuAPIClient implements RichMenuAPIClient {
    linkRichMenuToUser(opts: { richMenuId: string; userId: string }): Promise<void> {
        return Promise.resolve();
    }

    unlinkRichMenuFromUser(userId: string): Promise<void> {
        return Promise.resolve();
    }
}
